module.exports = __webpack_public_path__ + "static/wireframe1-507566906ea22fb909cda1628ca21f60.png";